export default __webpack_public_path__ + "static/media/10_photo.7b52348b.jpeg";